//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            puzzleOptions: {
                width: 261,
                height: 58
            },
            puzzles: [
                {
                    label: this.$lang.get('w2d1.game3.piranha'),
                    x: 820,
                    y: 710,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                },
                {
                    label: this.$lang.get('w2d1.game3.foot'),
                    x: 50,
                    y: 640,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    label: this.$lang.get('w2d1.game3.dog'),
                    x: 120,
                    y: 710,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    label: this.$lang.get('w2d1.game3.chameleon'),
                    x: 890,
                    y: 640,
                    correctDropAreaIndex: 3,
                    dropAreaIndex: -1
                },
                {
                    label: this.$lang.get('w2d1.game3.bat'),
                    x: 330,
                    y: 640,
                    correctDropAreaIndex: 4,
                    dropAreaIndex: -1
                },
                {
                    label: this.$lang.get('w2d1.game3.snake'),
                    x: 610,
                    y: 640,
                    correctDropAreaIndex: 5,
                    dropAreaIndex: -1
                }
            ],
            dropAreas: [
                {
                    xMin: 324,
                    xMax: 585,
                    yMin: 498,
                    yMax: 556
                },
                {
                    xMin: 377,
                    xMax: 638,
                    yMin: 241,
                    yMax: 299
                },
                {
                    xMin: 908,
                    xMax: 1169,
                    yMin: 301,
                    yMax: 359
                },
                {
                    xMin: 23,
                    xMax: 284,
                    yMin: 384,
                    yMax: 442
                },
                {
                    xMin: 629,
                    xMax: 890,
                    yMin: 316,
                    yMax: 374
                },
                {
                    xMin: 779,
                    xMax: 1040,
                    yMin: 577,
                    yMax: 635
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.correctDropAreaIndex === puzzle.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        },
        avatar () {
            return this.$store.getters.avatar;
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showHoverBg = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                puzzle.x >= area.xMin - this.puzzleOptions.width / 2 &&
                puzzle.x <= area.xMax - this.puzzleOptions.width / 2 &&
                puzzle.y >= area.yMin - this.puzzleOptions.height &&
                puzzle.y <= area.yMax
            );

            if (puzzle.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    puzzle.x = this.dropAreas[puzzle.dropAreaIndex].xMin;
                    puzzle.y = this.dropAreas[puzzle.dropAreaIndex].yMin;
                });
            }
        },
        dragmove (puzzle, { x, y }) {
            puzzle.x = x;
            puzzle.y = y;
        }
    }
};
